export function register(): Promise<ServiceWorkerRegistration | undefined> {

  const API_KEY  = process.env.REACT_APP_API_KEY;
  const AUTH_DOMAIN  = process.env.REACT_APP_AUTH_DOMAIN;
  const PROJECT_ID = process.env.REACT_APP_PROJECT_ID;
  const STORAGE_BUCKET  = process.env.REACT_APP_STORAGE_BUCKET;
  const MESSAGING_SENDER_ID  = process.env.REACT_APP_MESSAGING_SENDER_ID;
  const APP_ID  = process.env.REACT_APP_APP_ID;
  const MEASUREMENT_ID  = process.env.REACT_APP_MEASUREMENT_ID;

  const firebaseConfig ={
    apiKey: API_KEY || "",
    authDomain: AUTH_DOMAIN || "",
    projectId: PROJECT_ID || "",
    storageBucket: STORAGE_BUCKET || "",
    messagingSenderId: MESSAGING_SENDER_ID || "",
    appId: APP_ID || "",
    measurementId: MEASUREMENT_ID || ""
  }

  const firebaseConfigParam = encodeURIComponent(JSON.stringify(firebaseConfig));
  
    if ('serviceWorker' in navigator) {
      return new Promise((resolve, reject) => {
        navigator.serviceWorker
          .register(`/firebase-messaging-sw.js?firebaseConfig=${firebaseConfigParam}`)
          .then((registration) => {
            resolve(registration);
          })
          .catch((error) => {
            reject(error);
          });
    })
    }else {
      return Promise.resolve(undefined); // Return a resolved promise with undefined if service worker is not supported
    }
  }